import { getLaunchCvBase, getLaunchCorrelationId } from '@/shared/http';

export function withCorrelation(properties?: Record<string, string>): Record<string, string> {
    const result: Record<string, string> = {};
    const cvBase = getLaunchCvBase();
    const correlationId = getLaunchCorrelationId();
    if (cvBase) result['mscv'] = cvBase;
    if (correlationId) result['correlationId'] = correlationId;
    return { ...result, ...properties };
}
